export var peekdataApi = null;
export function setPeekdataApi(api) {
    peekdataApi = api;
}
